import { c as _c } from "react/compiler-runtime";
import type { ConfigInterface, NextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useContext } from 'react';
import { routes } from '../bff/routes';
import type { GetPolicyByUuidParams, GetPolicyByUuidResponse } from '../bff/types';
import { CoverageApiContext } from '../provider';
export function usePolicyByUuid(params, config) {
  const $ = _c(3);
  const {
    basePath
  } = useContext(CoverageApiContext);
  let t0;
  if ($[0] !== basePath || $[1] !== params) {
    t0 = routes.policyByUuid.getUrl(params, basePath);
    $[0] = basePath;
    $[1] = params;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useNextApiSubscription(t0, config);
}